import React from 'react';
import { QuizStep, QuizAnswer } from '../../lib/quiz-definition';

interface QuestionStepProps {
    step: QuizStep;
    onAnswer: (chosenAnswer: QuizAnswer) => void;
    onSkip: (skipToStepId: string) => void;
}

const QuestionStep: React.FC<QuestionStepProps> = ({ step, onAnswer, onSkip }) => {
    return (
        <div className="quiz-step-content">
            {step.content && (
                <h2 className="quiz-question-title">{step.content}</h2>
            )}
            <div className="quiz-options-list">
                {step.answers?.map((answer) => (
                    <button
                        key={answer.text}
                        onClick={() => onAnswer(answer)}
                        className="quiz-option-button"
                    >
                        <span className="quiz-option-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="12" cy="12" r="10" stroke="#D1D5DB" strokeWidth="2"/>
                            </svg>
                        </span>
                        <div className="quiz-option-text-container">
                            <h3 className="quiz-option-title">{answer.text}</h3>
                        </div>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default QuestionStep;